export const pallette = {
  main: '#C80000',
  white: '#FFFFFF',
  lightGray: '#F2F2F2',
  gray: '#8E8E8E',
  text: '#000000',
  error: '#ec6726',
  warn: '#FBEAE7',
  highlight: '#E3E3E3',
  caveatGrey: '#939393',
  green: '#0FAB3B',
}